let turnstileScriptPromise;

const loadTurnstile = () => {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (!turnstileScriptPromise) {
    turnstileScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src =
        "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => reject(new Error("No se pudo cargar Turnstile"));
      document.head.appendChild(script);
    });
  }
  return turnstileScriptPromise;
};

export const executeTurnstile = async (action = "request_otp") => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  if (!siteKey) {
    return "";
  }
  const turnstile = await loadTurnstile();
  return new Promise((resolve, reject) => {
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.width = "1px";
    container.style.height = "1px";
    container.style.right = "0";
    container.style.bottom = "0";
    container.style.opacity = "0";
    container.style.pointerEvents = "none";
    container.style.overflow = "hidden";
    document.body.appendChild(container);
    let widgetId;
    const cleanup = () => {
      if (widgetId !== undefined) {
        turnstile.remove(widgetId);
      }
      container.remove();
    };
    const timer = window.setTimeout(() => {
      cleanup();
      reject(new Error("La verificación de seguridad expiró"));
    }, 15000);
    widgetId = turnstile.render(container, {
      sitekey: siteKey,
      size: "invisible",
      action,
      callback: (token) => {
        window.clearTimeout(timer);
        cleanup();
        resolve(token);
      },
      "error-callback": () => {
        window.clearTimeout(timer);
        cleanup();
        reject(new Error("No se pudo completar la verificación de seguridad"));
      },
    });
    turnstile.execute(widgetId);
  });
};
